import React, { useState } from 'react';
import BackButton from '../Components/BackButton';
import { useAlert } from '../Context/AlertContext';
import GlobalAlert from '../Components/GlobalAlert'

export default function Contact() {
  const { showAlert, alert } = useAlert(); // Extract alert state
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    Name: '',
    LastName: '',
    Email: '',
    Message: '',
    Subject: '',
  });
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
  
    try {
      const response = await fetch(
        'https://x95nw9pp7b.execute-api.eu-central-1.amazonaws.com/live/service-email-sender',
        {
          mode:'no-cors',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...formData,
            ServiceID: parseInt(1), // You can replace 1 with a dynamic value later
          }),
        }
      );
  
      if (response.ok) {
        showAlert("Your message has been sent successfully!", "success");
        setFormData({
          Name: '',
          LastName: '',
          Email: '',
          Message: '',
          Subject: '',
        });
      } else {
        showAlert("Your message has been sent successfully!", "success");
        setFormData({
          Name: '',
          LastName: '',
          Email: '',
          Message: '',
          Subject: '',
        });
      }
  
    } catch (error) {
      console.error("❌ Error sending message:", error);
      showAlert("There was an error sending your message. Please try again later.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  return (
    <section id="hero">
      <GlobalAlert/>
      <div data-aos="zoom-in" className="container d-flex flex-column justify-content-center py-5" style={{ height: '100vh', position: 'relative' , zIndex:'2' }}>
        <div style={{ position: 'absolute', top: '1rem', left: '0' }}>
          <BackButton />
        </div>

        <div>
          <h1 className="bold pt-4">
            Contact <span className="spangreen"> Us</span>
          </h1>

          <p>
            Have a question or inquiry? <br /> Send us a message, and our team
            will get back to you shortly.
          </p>


          <form className="rounded shadow-sm mt-4" style={{ maxWidth: '60rem' }} onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="Name"
                    placeholder="Enter your name"
                    value={formData.Name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="mb-3">
                  <label htmlFor="lastName" className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="LastName"
                    placeholder="Enter your last name"
                    value={formData.LastName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="Email"
                className="form-control"
                id="Email"
                placeholder="name@example.com"
                value={formData.Email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="subject" className="form-label">Subject</label>
              <input
                type="text"
                className="form-control"
                id="Subject"
                placeholder="Subject of your message"
                value={formData.Subject}
                onChange={handleInputChange}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="message" className="form-label">Message</label>
              <textarea
                className="form-control"
                id="Message"
                rows="4"
                placeholder="Write your message here..."
                value={formData.Message}
                onChange={handleInputChange}
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-100"
              disabled={isLoading} // Disable the button when loading
            >
              {isLoading ? (
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                'Send Message'
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
